import React, { useRef, useState, useEffect } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import BlockContainer from './BlockContainer';
import Button from '../Button';

const imageType = 'image/png';
const canvasFont = `normal 60px 'Dancing Script'`;

const handleDownload = (image) => {
  if (!image) return;
  const dlink = document.createElement('a');
  dlink.setAttribute('href', image);
  dlink.setAttribute('download', 'signature.png');
  dlink.click();
};

export default function Signature({
  title,
  description,
  bgColor,
  textColor,
  padding,
}) {
  const [sigImage, setSigImage] = useState(null);
  const [sigText, setSigText] = useState('');
  const [tab, setTab] = useState('draw');
  const sigCanvas = useRef(null);

  const handleSignature = () => {
    const image = sigCanvas.current.getTrimmedCanvas().toDataURL(imageType);
    setSigImage(image);
  };

  const handleClear = () => {
    if (!sigCanvas) return;
    sigCanvas.current.clear();
  };

  useEffect(() => {
    if (window.shutdownIntercom) {
      window.shutdownIntercom();
    }
  }, []);

  const handleText = () => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    ctx.font = canvasFont;
    const metrics = ctx.measureText(sigText);
    canvas.width = metrics.width;
    canvas.height =
      metrics.fontBoundingBoxAscent + metrics.fontBoundingBoxDescent;
    ctx.font = canvasFont;
    ctx.fillText(sigText, 0, canvas.height - metrics.fontBoundingBoxDescent);
    const image = canvas.toDataURL(imageType);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    handleDownload(image);
  };

  return (
    <BlockContainer
      bgColor={bgColor}
      textColor={textColor}
      padding={padding}
      title={title}
      description={description}
    >
      <div
        className="text-sm lg:leading-[40px] lg:text-[20px] bg-white inline-block rounded-full mb-6"
        style={{ backgroundColor: 'var(--stone-600)' }}
      >
        <button
          type="button"
          onClick={() => setTab('draw')}
          className={`px-10 m-0 rounded-full transition-all transition-500 py-2 ${
            tab === 'draw' ? `bg-midnight text-white ` : 'pr-8'
          } `}
        >
          Draw
        </button>
        <button
          type="button"
          onClick={() => setTab('type')}
          className={`px-10 m-0 rounded-full  transition-all transition-500  py-2 ${
            tab === 'type' ? `bg-midnight  text-white ` : 'pl-8'
          } `}
        >
          Type
        </button>
      </div>
      <div className="flex flex-col items-center gap-6">
        {tab === 'draw' && (
          <>
            <SignatureCanvas
              ref={sigCanvas}
              canvasProps={{
                className:
                  'bg-white rounded-lg shadow-md w-full max-w-[500px] h-[200px]',
              }}
              onEnd={() => handleSignature()}
            />
            <div className="flex gap-4">
              <Button
                outline
                disabled={!sigImage}
                onClick={() => handleClear()}
              >
                Clear
              </Button>
              <Button
                solid
                yellow
                disabled={!sigImage}
                onClick={() => handleDownload(sigImage)}
              >
                Download
              </Button>
            </div>
          </>
        )}
        {tab === 'type' && (
          <>
            <input
              className="px-6 py-4 text-4xl text-center bg-white rounded-lg shadow-md text-black placeholder:text-black/30 w-full max-w-[500px]"
              style={{ fontFamily: 'Dancing Script', fontWeight: 400 }}
              onChange={(e) => setSigText(e.target.value)}
              placeholder="Your name here"
              type="text"
              name="signature"
              value={sigText}
            />
            <div className="flex flex-col md:flex-row gap-4">
              <Button
                outline
                disabled={!sigText}
                onClick={() => setSigText('')}
              >
                Clear
              </Button>
              <Button
                solid
                yellow
                disabled={!sigText}
                onClick={() => handleText()}
              >
                Download
              </Button>
            </div>
          </>
        )}
      </div>
    </BlockContainer>
  );
}
